import { QueryClient } from '@tanstack/react-query';
import { isAxiosError } from 'axios';

/** A server rate refusal needs a later gesture, not the normal read retry burst. */
export const shouldRetryDashboardQuery = (failureCount: number, error: unknown, maxRetries = 3) =>
  !(isAxiosError(error) && error.response?.status === 429) && failureCount < maxRetries;

export const createDashboardQueryClient = () =>
  new QueryClient({
    defaultOptions: { queries: { retry: shouldRetryDashboardQuery } },
  });
